/*
 * @Author: sunny
 * @Date: 2019-10-19 17:49:17
 * @Last Modified by:
 * @Last Modified time:
 * 导航栏个人信息面板下Enrolment的弹窗
 */
 <template>
  <v-dialog v-model="enrolmentData.dialog"
            width="800">
    <v-card class="blue-title">
      <v-card-title class="headline text-xs-center font-weight-bold"
                    primary-title>
        <v-spacer></v-spacer>
        Top Levels — supplemental policy for top tutors
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text>
        <p>Your “enrolment bonus” goes with your entire contribution in trial class conversions. It will no longer be affected by your instant (monthly) conversion rate《Top Rotation Scheme》. You “Enrolment Levels” decide how much you can get from each student enrolment. Please refer to the chart below:</p>
        <p><b>Guidelines:</b><br>
        1.For new tutors, it’s easier to achieve a new top level but it’s somehow harder in the beginning to accomplish more trial classes. Just do your best in each trial class, get your conversion rate up gradually, with it, you will have more bookings and enrolments.<br>
        2.For experienced tutors, each enrolment means more income. Take it professionally and become the TOPest.</p>
      </v-card-text>
      <v-card-text>
        <v-data-table :headers="headers"
                      :items="desserts"
                      hide-actions
                      class="common-table text-xs-center">
          <template slot="items"
                    slot-scope="props">
            <td class="blue-title">{{ props.item.concern }}</td>
            <td class="blue-title" v-html="props.item.points"></td>
            <td class="blue-title">{{props.item.bonus}}</td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'enrolment',
  props: {
    enrolmentData: {
      dialog: false
    }
  },
  data: () => ({
    headers: [
      {
        text: 'TOP LEVEL',
        align: 'center',
        sortable: false,
        value: 'concern'
      },
      {
        text: 'Enrolments to complete',
        align: 'center',
        sortable: false,
        value: 'points'
      },
      {
        text: 'Enrolment Bonus (100PHP = 1.9 USD)',
        align: 'center',
        sortable: false,
        value: 'bonus'
      }
    ],
    desserts: [
      {
        concern: '0',
        points: '0',
        bonus: '0 PHP'
      }, {
        concern: '1',
        points: '30',
        bonus: '50 PHP'
      }, {
        concern: '2',
        points: '50',
        bonus: '100 PHP'
      }, {
        concern: '3',
        points: '80',
        bonus: '150 PHP'
      }, {
        concern: '4',
        points: '130',
        bonus: '200 PHP'
      }, {
        concern: '5',
        points: '210',
        bonus: '250 PHP'
      }, {
        concern: '6',
        points: '340',
        bonus: '300 PHP'
      }, {
        concern: '7',
        points: '550',
        bonus: '350 PHP'
      }, {
        concern: '8',
        points: '890',
        bonus: '400 PHP'
      }, {
        concern: '9',
        points: '1440',
        bonus: '450 PHP'
      }, {
        concern: '10',
        points: '≥2330',
        bonus: '500 PHP'
      }
    ]
  }),
  methods: {
    show () {
      this.enrolmentData.dialog = true
    }
  }

}
</script>
<style lang="scss" scoped>
.blue-title{
    @include font_color($font-color-theme);
}
</style>
